import axios from 'axios';

/**
 * Creates an authenticated axios instance
 * @param {string} idToken - The Auth0 ID token from user context
 * @returns {AxiosInstance} Configured axios instance with auth headers
 */
export const createAuthenticatedClient = (idToken) => {
  const client = axios.create({
    headers: {
      'Authorization': `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
  });

  // Add response interceptor for error handling
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        console.error('Unauthorized request - token may be expired');
        // Could trigger logout here if needed
        // window.location.href = '/';
      }
      return Promise.reject(error);
    }
  );

  return client;
};

/**
 * Helper to get auth headers object
 * @param {string} idToken - The Auth0 ID token
 * @returns {Object} Headers object with Authorization
 */
export const getAuthHeaders = (idToken) => ({
  'Authorization': `Bearer ${idToken}`,
  'Content-Type': 'application/json',
});
